<template>
  <div style="height: 730px;width:450px;">

      <div class="box" style="height: 100px;margin-bottom: 60px">
        <div style="height:100px;width:100px;margin-right:40px">
          <img v-if="peopleInfo.headPic" :src="peopleInfo.headPic" style="height: 100%;width:100%;border-radius: 50%">
        </div>
        <div class="box_f1 box_v" style="justify-content: space-between;padding:20px 0 10px;">
          <div style="font-size: 28px;color:#4d4d4d;">{{peopleInfo.name}}</div>
          <div style="font-size: 24px;color:#9a9a9a;">{{peopleInfo.phone}}</div>
        </div>
      </div>

      <div style="font-size:30px;color:#4d4d4d;">
        <div v-for="(item,index) in shijian" :key="index">
          <div class="box">
            <div>{{item.title + "："}}</div>
            <div class="box_f1" style="display: inline-block;word-break: break-all">{{item.info}}</div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

  export default {
    props:{
      peopleInfo:Object,
      shijian:Array
    },
    data () {
      return {
        // shijian:[{
        //   title:'事件编号',
        //   info:'20190111001'
        // },{
        //   title:'上报时间',
        //   info:'20190111001'
        // },{
        //   title:'事件详情',
        //   info:'蒲瑞祥园33号楼东侧墙角垃圾成堆，无人清理，严重污染环境，影响区民日常生活，希望尽快安排相关人员清理社区垃圾，并进行有关社区卫生的宣传与监督'
        // },{
        //   title:'事件地点',
        //   info:'蒲瑞祥园33号楼东侧'
        // }]
      }
    },
    components: {

    }
  }
</script>

<style scoped>
.slh{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
</style>
